import { render, staticRenderFns } from "./ImgItem.vue?vue&type=template&id=a54d3934&scoped=true"
import script from "./ImgItem.vue?vue&type=script&lang=js"
export * from "./ImgItem.vue?vue&type=script&lang=js"
import style0 from "./ImgItem.vue?vue&type=style&index=0&id=a54d3934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54d3934",
  null
  
)

export default component.exports